import React, { useEffect } from "react";
import WeekDateCalendarCard from "Pages/MyScheduleBeta/CommonComponents/WeekDateCalendarCard";
import { useScheduleBetaContext } from "Pages/MyScheduleBeta/Context/ScheduleBetaContext";
import {
  toISTStart,
  toISTEnd,
  fromISTStart,
  fromISTEnd,
} from "Pages/MyScheduleBeta/utils/dateHelpers";
import { subDays, addDays } from "date-fns";
import { DAY_WEEK_TYPE } from "Pages/MyScheduleBeta/utils/constants";

// ─── Component ────────────────────────────────────────────────────────────────

const MyScheduleCalendarHeader: React.FC = () => {
  const {
    selectedDate,
    setSelectedDate,
    filterState,
    setFilterState,
    eventType,
    todayDate,
    setEventType,
  } = useScheduleBetaContext();
  const [startDate, setStartDate] = React.useState<Date>(new Date());
  const [endDate, setEndDate] = React.useState<Date>(new Date());
  const getDayModeRange = () => {
    const selDate = new Date(selectedDate);
    const start = subDays(selDate, 3);
    const end = addDays(selDate, 3);
    return { start, end };
  };
  useEffect(() => {
    if (eventType === DAY_WEEK_TYPE.WEEK) {
      console.log("filterStatefilterState", filterState);
      const start = filterState.startDate
        ? fromISTStart(filterState.startDate)
        : new Date();
      const end = filterState.endDate
        ? fromISTEnd(filterState.endDate)
        : new Date();
      setStartDate(start);
      setEndDate(end);
    } else {
      const selDate = selectedDate ? new Date(selectedDate) : new Date();
      setStartDate(selDate);
      setEndDate(selDate);
    }
  }, [eventType, selectedDate, filterState.startDate, filterState.endDate]);

  const handleDateClick = (date: Date) => {
    // Format date to YYYY-MM-DD
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const dateStr = `${y}-${m}-${d}`;
    setSelectedDate(dateStr);
    if (eventType === DAY_WEEK_TYPE.WEEK) {
      setEventType(DAY_WEEK_TYPE.DAY);
      setStartDate(date);
      setEndDate(date);
    }
    setFilterState((prev) => ({
      ...prev,
      startDate: toISTStart(date),
      endDate: toISTEnd(date),
    }));

    setStartDate(date);
    setEndDate(date);
  };

  const navigateWeek = (direction: -1 | 1) => {
    if (eventType === DAY_WEEK_TYPE.WEEK) {
      setFilterState((prev) => {
        const currentStart = prev.startDate
          ? fromISTStart(prev.startDate)
          : new Date();
        const currentEnd = prev.endDate ? fromISTEnd(prev.endDate) : new Date();

        const newStart = new Date(currentStart);
        newStart.setDate(newStart.getDate() + direction * 7);
        const newEnd = new Date(currentEnd);
        newEnd.setDate(newEnd.getDate() + direction * 7);

        return {
          ...prev,
          startDate: toISTStart(newStart),
          endDate: toISTEnd(newEnd),
        };
      });
    } else {
      const currentSelected = new Date(selectedDate);
      currentSelected.setDate(currentSelected.getDate() + direction);

      const y = currentSelected.getFullYear();
      const m = String(currentSelected.getMonth() + 1).padStart(2, "0");
      const d = String(currentSelected.getDate()).padStart(2, "0");
      const newSelectedStr = `${y}-${m}-${d}`;

      setSelectedDate(newSelectedStr);
      setFilterState((prev) => ({
        ...prev,
        startDate: toISTStart(currentSelected),
        endDate: toISTEnd(currentSelected),
      }));
    }
  };

  // Month + Year label derived from the visible week
  const monthLabel = startDate.toLocaleString("default", {
    month: "long",
  });
  console.log("startDate", getDayModeRange);
  return (
    <div style={styles.container}>
      {/* ── Week navigation bar ── */}
      <div style={styles.navBar}>
        <button
          style={styles.navBtn}
          onClick={() => navigateWeek(1)}
          aria-label="Next week"
        >
          ‹
        </button>

        <span style={styles.monthLabel}>{monthLabel.slice(0, 3)}</span>

        <button
          style={styles.navBtn}
          onClick={() => navigateWeek(-1)}
          aria-label="Previous week"
        >
          ›
        </button>
      </div>
      <WeekDateCalendarCard
        startDate={startDate}
        endDate={endDate}
        activeDate={selectedDate}
        onDateClick={handleDateClick}
        showDots
        todayDate={todayDate}
      />
    </div>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles: Record<string, React.CSSProperties> = {
  container: {
    width: "100%",
    marginTop: "8px",
    display: "flex",
    background: "white",
    alignItems: "stretch",
    padding: 0,
    flexShrink: 0,
    borderTop: "1px solid #E2E8F0",
    borderBottom: "1px solid #E2E8F0",
  },
  navBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 4px",
    background: "#0F172A",
    flexDirection: "column",
  },
  navBtn: {
    background: "none",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
    lineHeight: 1,
    padding: "2px 8px",
    borderRadius: "6px",
    transition: "background 0.15s",
    transform: "rotate(90deg)",
    color: "#fff",
  },
  monthLabel: {
    fontSize: "13px",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: "0.3px",
    transform: "rotate(180deg)",
    writingMode: "vertical-lr",
  },
};

export default MyScheduleCalendarHeader;
